import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { ProductsRequestModel } from '../../helpers/objects/request/products/products-request-model';
import { map, Observable } from 'rxjs';
import { ProductsResponseModel } from '../../helpers/objects/response/products/products-response-model';
import { ProductsModel } from '../../helpers/objects/dto/products/products-model';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {
  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfig: EnvironmentModel) {}

  get(filter: ProductsRequestModel): Observable<any> {
    const httpParams: HttpParams = new HttpParams({
      fromObject: filter as any
    });
    return this.http
      .get<any>(this.appConfig.api + 'setup/products-info/' + this.appConfig.apiPartnershipId, {
        params: httpParams
      })
      .pipe(
        map((response) => {
          return {
            productsResponse: response.body as ProductsResponseModel,
            products: response.body.products as ProductsModel
          };
        })
      );
  }

  getProductDocuments(productTag: any , type?: string): Observable<ProductsModel> {
    let params = new HttpParams().set('documentType', type ?? '');
    return this.http
      .get<any>(this.appConfig.api + 'setup/products-info/' + this.appConfig.apiPartnershipId + '/' + encodeURIComponent(productTag) + '/documents', {params})
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  GetDocumentProduct(url: string) {
    return this.http.get<any>(url);
  }

  ArrayBufferToBase64(buffer: any) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const length = bytes.byteLength;

    for (let i = 0; i < length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  }

  public getProductImage(documentId: string): Observable<any> {
    const token = sessionStorage.getItem('token');
    let params = new HttpParams().set('digitalArchiveFileId', documentId);
    params = token ? params.set('Authorization', token) : params;
    return this.http.get<any>(this.appConfig.api + 'setup/products-info/' + this.appConfig.apiPartnershipId + '/content', { params });
  }
}
